import React, { useState } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import styles from './manager.module.css';
import back from '../../assets/icons/back.svg';
import InsertBar from '../../components/InsertBar';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { Box, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";

function DepartmentAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [department_name, setDepartmentName] = useState("");
  const [department_name_short, setDepartmentNameShort] = useState("");
  const [number_of_people, setNumberOfPeople] = useState("");
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handlePrevious = () => {
    if (department_name.trim() || department_name_short.trim() || number_of_people!="") {
      setShowCancelModal(true); 
    } else {
      navigate('/departmentManager');
    }
  };

  const confirmCancelChanges = () => {
    setShowCancelModal(false);
    navigate('/departmentManager'); 
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleUpdate = async () => {
    if (!department_name.trim() || !department_name_short.trim()) {
      handleError("กรุณากรอกข้อมูลให้ครบถ้วน");
      return;
    }
    setShowUpdateModal(true);
  };
  
  const confirmedUpdate = async () => {
    setLoading(true);
    const res = await api.newDepartment(department_name.trim(),department_name_short.trim(),parseInt(number_of_people,10));
    setLoading(false);
  
    if (res) {
      if (res['data']['code'] === 200) {
        setShowUpdateModal(false); 
        navigate('/departmentManager');
      } else {
        handleError(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };

  const handleCloseModal = () => {
    setShowUpdateModal(false);
  };

  const handleCloseErrorModal = () => setErrorMessage(null);
  const handleCloseCancelModal = () => setShowCancelModal(false);

  return (
    <>
      <Loader loading={loading} />
      {showUpdateModal && (
        <CustomizedModal
          onClose={handleCloseModal}
          apiCall={confirmedUpdate}
          confirmMessage={`ยืนยันที่จะเพิ่มข้อมูล`}
          confirmButtonText={`ยืนยัน`}
        />
      )}
      {errorMessage && (
        <CustomizedModal
          onClose={handleCloseErrorModal}
          confirmMessage={errorMessage}
          apiCall={handleCloseErrorModal} // No action required, just closes
          confirmButtonText={`ตกลง`}
        />
      )}
      {showCancelModal && (
        <CustomizedModal
          onClose={handleCloseCancelModal}
          apiCall={confirmCancelChanges}
          confirmMessage={`ยกเลิกการเปลี่ยนแปลง?`}
          confirmButtonText={`ตกลง`}

        />
      )}
      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการสังกัด
      </Box>
      <Box className={styles.head1Text}>เพิ่มข้อมูลสังกัดใหม่</Box>
      <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
        <Box className={styles.head2Text}>ชื่อสังกัด</Box>
        <InsertBar
          currentValue={department_name}
          setNewValue={setDepartmentName}
          placeholder="ชื่อสังกัด"
        />
        <Box className={styles.head2Text} sx={{marginTop: 1}}>ตัวย่อชื่อสังกัด</Box>
        <InsertBar
          currentValue={department_name_short}
          setNewValue={setDepartmentNameShort}
          placeholder="ตัวย่อชื่อสังกัด"
        />
        <Box className={styles.head2Text} sx={{marginTop: 1}}>จำนวนกำลังพล</Box>
        <InsertBar
          currentValue={number_of_people}
          setNewValue={(value) => {
            if (/^\d*$/.test(value)) {
              setNumberOfPeople(value ? Number(value) : 0);
            }
          }}  
          placeholder="จำนวนกำลังพล"
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 , marginRight: 4.3}}>
        <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            sx={{ padding: 1, borderRadius: 1.5 }}
        >
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
        </Button>
      </Box>
    </>
  );
}

export default DepartmentAdd;
